/**
 * Supabase Client Configuration for SubscriptionManager
 */
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;

if (!supabaseUrl || !supabaseKey) {
  console.error('❌ Supabase URL or Key not configured. Check your environment variables.');
}

export const supabase = createClient(supabaseUrl || '', supabaseKey || '', {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});

/**
 * Helper function to get the current session
 */
export const getSession = async () => {
  const { data: { session }, error } = await supabase.auth.getSession();
  if (error) {
    return null;
  }
  return session;
};

/**
 * Helper function to get the current user
 */
export const getCurrentUser = async () => {
  const { data: { user }, error } = await supabase.auth.getUser();
  if (error) {
    return null;
  }
  return user;
};

/**
 * Helper function to get user profile from profiles table
 * @param {string} userId - The user ID
 * @param {string|null} token - Optional access token (if not provided, reads from localStorage)
 */
export const getUserProfile = async (userId, token = null) => {
  // Use backend API instead of direct Supabase query (bypasses RLS issues)
  try {
    const accessToken = token || localStorage.getItem('access_token');
    if (!accessToken) {
      console.warn('[getUserProfile] No access token available');
      return null;
    }

    const API_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
    console.log('[getUserProfile] Fetching profile for user:', userId);

    const response = await fetch(`${API_BASE}/api/user/profile`, {
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      console.error('[getUserProfile] API error:', response.status, response.statusText);
      // Log response body for debugging
      try {
        const errorBody = await response.text();
        console.error('[getUserProfile] Error body:', errorBody);
      } catch (e) {
        // Ignore parsing errors
      }
      return null;
    }

    const result = await response.json();
    const data = result.profile;

    console.log('[getUserProfile] Success:', data?.email, 'is_admin:', data?.is_admin, 'plan:', data?.subscription_plan);
    return data;
  } catch (error) {
    console.error('[getUserProfile] Exception:', error);
    return null;
  }
};

export default supabase;
